module.exports = __webpack_public_path__ + "assets/img/e3a0d6281a9df83755229ad8ef0a544a.svg";